import axios from 'axios'
import React, { useState, useEffect } from 'react';

function useCountries() {

  const [data, setData] = useState([])
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState([])
  const [isos, setIsos] = useState([])
  const isMountedRef = React.useRef(true); // Track if component is mounted

  useEffect(() => {
    async function getAllCountries() {
      try {
        const { data } = await axios.get('/api/v1/countries')

        // Only update state if component is still mounted
        if (isMountedRef.current) {
          setData(data)
          setIsos(data.map(country => country.iso))
          setLoading(false)
        }
      } catch (e) {
        if (isMountedRef.current) {
          setError(e)
          setLoading(false)
        }
      }
    }

    getAllCountries()

    // Cleanup function to prevent memory leaks
    return () => {
      isMountedRef.current = false;
    };
  }, [])

  return {
    data,
    loading,
    error,
    isos
  }
}

export default useCountries
